module.exports = __webpack_public_path__ + "static/emp-0bc85db5b5e5f529584c63fdbcf0b888.png";